import { BaseElements, BaseObject, BaseService, BaseInjector } from '../../js/base';
import { querySelector } from '../../utility/utils';

class Texts extends BaseObject { }
class ClassList extends BaseObject { }
class Selectors extends BaseObject {
    adsWrappers = '.header-ads';
    header = '.header-with-sidebar';
    headerSideMenu = "#header-side-menu";
    publicationMenu = '.publication__menu';
    disableScrolling = '.disable-scrolling'; // add this class to disable the scrolling on specific places
}
class Elements extends BaseElements<Selectors> {
    adsWrappers: HTMLElement;
    header: HTMLElement;
    headerSideMenu: HTMLElement;
    publicationMenu: HTMLElement;
    disableScrolling: HTMLElement;
    constructor(readonly selectors: Selectors) {
        super(selectors, false);
    }

    setWrapper() {
        this.initElements();
    }

    initElements() {
        this.adsWrappers = querySelector(this.selectors.adsWrappers);
        this.header = querySelector(this.selectors.header);
        this.headerSideMenu = querySelector(this.selectors.headerSideMenu);
        this.publicationMenu = querySelector(this.selectors.publicationMenu);
        this.disableScrolling = querySelector(this.selectors.disableScrolling);
    }

}
interface Scrolling extends BaseService<Selectors, Elements, ClassList, Texts> { }
@BaseInjector(Selectors, Elements, ClassList, Texts)
class Scrolling {
    prevScrollpos: number;

    get isSidebarOpened(): boolean {
        return this.elements.headerSideMenu.classList.contains("show")
    }

    get disableScrolling(): boolean {
        const disableScrolling = this.elements.disableScrolling;
        return disableScrolling ? true : false
    }

    constructor() {
        this.prevScrollpos = window.scrollY;
    }

    initialize() {
        this.setElements();
        window.onscroll = () => {
            this.scrollHandler()
        };
        $(this.selectors.headerSideMenu).on('shown.bs.collapse', e => {
            this.scrollHandler()
        });
    }

    setElements(): void {
        this.elements.setWrapper();
    }

    scrollHandler(): void {
        let adsWrappersHeight = this.elements.adsWrappers?.offsetHeight || 0;
        let publicationMenuHeight = this.elements.publicationMenu?.offsetHeight || 0;
        const { height: headerHeight, top: headerTop } = this.elements.header.getBoundingClientRect();
        let offset = headerHeight + headerTop;
        let currentScrollPos = window.pageYOffset;
        if (this.elements.headerSideMenu) {
            this.elements.headerSideMenu.style.top = offset + 'px';
            this.elements.headerSideMenu.style.maxHeight = `calc(100% - ${offset}px )`;
            if (offset < 0) {
                this.elements.headerSideMenu.style.top = '0';
            }
            if (this.disableScrolling) {
                return;
            }
        }
        if (this.prevScrollpos >= currentScrollPos) {
            this.elements.header.style.top = `0px`;
            if (this.elements.publicationMenu) {
                this.elements.publicationMenu.style.top = `${headerHeight}px`;
            }
        } else {
            if (!this.isSidebarOpened) {
                this.elements.header.style.top = `-${adsWrappersHeight + headerHeight}px`;
            }
            if (this.elements.publicationMenu && !this.isSidebarOpened) {
                this.elements.publicationMenu.style.top = `-${adsWrappersHeight + headerHeight + publicationMenuHeight}px`;
            }
        }
        this.prevScrollpos = currentScrollPos;
    }


}

export default Scrolling;

export {
    Elements as HeaderElements,
    Selectors as HeaderSelectors,
    ClassList as HeaderClassList,
    Texts as HeaderTexts
}
